import { IconProps } from "@chakra-ui/react";
import Collaborate from "./Iconify/Collaborate";

export default function CaminoPeopleTeamIcon(props: IconProps) {
  return <Collaborate {...props} />;
}
